import ApiClient from "src/utils/ApiClient";
import reportErrorToNewRelic from "src/Pages/Company/OrganizationStructure/utils/NewRelicReporter/reportErrorToNewRelic";

export const OrganizationStructureApiClient = new ApiClient({
  baseURL: `/api/organization-structure/omb`,
  headers: {},
}).client;

OrganizationStructureApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    reportErrorToNewRelic(error, "OrganizationStructure API error");
    return Promise.reject(error);
  }
);

export const EmployeeApiClient = new ApiClient({
  baseURL: `/api/employee-management`,
  headers: {},
}).client;

EmployeeApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    reportErrorToNewRelic(error, "EmployeeManagement API error");
    return Promise.reject(error);
  }
);
